
import Context from "../../storage/context";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteConfirmModal from "../DeleteConfirmModal/DeleteConfirmModal";
import axios from "axios";


const CarCardEdit = (car) => {

    const navigate = useNavigate();
    const [popup, setPopup] = useState(false);
    let ctx = useContext(Context);


    const onEdit = () => {
        localStorage.setItem("car", JSON.stringify(car.data));
        navigate("/edit", { replace: true });
    }

    function formatNumber(numStr) {
        return Number(numStr).toLocaleString("en-US");
    }

    const onDelete = () => {
        if (!popup) {
            ctx.setDeleteCar(car.data.car_id);
        } else {
            ctx.setDeleteCar("");
        }
        setPopup(!popup);

    }

    const onConfirm = async () => {
        const res = await axios.delete(`${ctx.api_url}/cars/${ctx.delete_car}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        });
        console.log(res);
        setPopup(false);
        ctx.setDeleteCar("");
    }





    return (
        <>
            <div className="car-card" id={car.data.car_id}>
                <div className="car-img">
                    <div className="car-img-bg" style={{ background: `radial-gradient(ellipse at 50% 100%, ${car.data.color}, #05090f)` }}>
                        <span className="car-badge">{car.data.tag}</span>
                        <img src={`${ctx.api_url}${car.data[car.data.who_is_p]}`} alt={"car"} loading="lazy" />
                        {car.data.isSale === "yes" && <div className="sold-ribbon">נמכר</div>}
                    </div>

                </div>
                <div className="car-body">
                    <div className="car-name">{car.data.car_make + " " + car.data.car_full_type}</div>
                    <div className="car-meta">
                        <span className="car-year">{car.data.year}</span>
                        <span className="car-year">{formatNumber(car.data.km)} ק״מ</span>
                        <span className="car-year">יד {car.data.hand} </span>
                        <span className="car-year">{formatNumber(car.data.engine)} סמ"ק  </span>
                    </div>
                    <div className="car-divider" />
                    <div className="car-price-row">
                        <div>
                            <div className="car-price">{formatNumber(car.data.price)} ₪</div>
                            <div className="car-price-label">כולל מע״מ</div>
                        </div>
                        <button className="car-cta-btn" onClick={onEdit}>לעריכה</button>
                        <button className="car-cta-btn" onClick={onDelete}>מחיקה</button>
                    </div>
                </div>

            </div>
            {popup && <DeleteConfirmModal open={popup} onClose={onDelete} onConfirm={onConfirm} carName={car.data.car_make + " " + car.data.car_full_type} />}
        </>
    );
};

export default CarCardEdit;